/** Дата рождения: парсинг ввода и проверки как на сервере (14–100 лет, не в будущем). */

export function formatDateForServer(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function parseIsoToLocalDate(iso) {
  const m = String(iso || '').slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

/** ISO YYYY-MM-DD (или начало строки с датой) → ДД.ММ.ГГГГ; без разбора через Date (часовые пояса). */
export function isoToRuDisplay(iso) {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso).trim());
  if (!m) return '';
  return `${m[3]}.${m[2]}.${m[1]}`;
}

/**
 * Разбор строки: ГГГГ-ММ-ДД или ДД.ММ.ГГГГ (точка, слэш, дефис).
 * @returns {{ ok: true, iso: string } | { ok: false, error: string }}
 */
export function parseBirthDateInput(raw) {
  if (raw == null || String(raw).trim() === '') {
    return { ok: false, error: 'Укажите дату рождения' };
  }
  const parts = normalizeToYmd(String(raw).trim());
  if (!parts) {
    return {
      ok: false,
      error: 'Неверный формат. Пример: 15.03.2000 или 2000-03-15'
    };
  }
  const { y, mo, d } = parts;
  const date = new Date(Date.UTC(y, mo - 1, d));
  if (date.getUTCFullYear() !== y || date.getUTCMonth() !== mo - 1 || date.getUTCDate() !== d) {
    return { ok: false, error: 'Некорректная дата' };
  }
  const today = new Date();
  const todayUtc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const birthUtc = Date.UTC(y, mo - 1, d);
  if (birthUtc > todayUtc) {
    return { ok: false, error: 'Дата рождения не может быть в будущем' };
  }
  const ageMs = todayUtc - birthUtc;
  const ageYears = ageMs / (365.25 * 24 * 60 * 60 * 1000);
  if (ageYears < 14) {
    return { ok: false, error: 'Возраст должен быть не менее 14 лет' };
  }
  if (ageYears > 100) {
    return { ok: false, error: 'Проверьте указанную дату' };
  }
  const iso = `${y}-${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  return { ok: true, iso };
}

function normalizeToYmd(s) {
  let m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(s);
  if (m) {
    return { y: Number(m[1]), mo: Number(m[2]), d: Number(m[3]) };
  }
  m = /^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/.exec(s);
  if (m) {
    return { d: Number(m[1]), mo: Number(m[2]), y: Number(m[3]) };
  }
  return null;
}
